import { Inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuard implements CanActivate {
  constructor(
    @Inject(AuthService) private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise((resolve) => {
      this.authService.getAuth().onAuthStateChanged(async (user) => {
        if (!user) {
          resolve(true);
          return;
        }

        const isAdmin = await this.authService.ensureAdminAccess();
        if (isAdmin) {
          this.router.navigate(["/dashboard"]);
          resolve(false);
          return;
        }

        // Autenticado no Auth, mas sem registro em user_admin: libera a tela de login.
        resolve(true);
      });
    });
  }
}
